import axios from '../axios';

export default {
  downloadListClient (dateFrom, dateTo) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/client-form-1?date_from=${dateFrom}&date_to=${dateTo}`, { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  downloadSubscriber (dateFrom, dateTo) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/abonent-form-1?date_from=${dateFrom}&date_to=${dateTo}`, { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  downloadApartmentForm () {
    return new Promise((resolve, reject) => {
      axios.get('/report/apartment-form-1', { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  downloadFullReportFormDoorphone () {
    return new Promise((resolve, reject) => {
      axios.get('/report/doorphone-form-1', { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  downloadServiceDoorCodeStats (days) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/service-door-code-stats?days=${days}`, { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  downloadPersonalAccountForm () {
    return new Promise((resolve, reject) => {
      axios.get('/report/personal-account-form-1', { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  obtainingIndicatorsDoorphone () {
    return new Promise((resolve, reject) => {
      axios.get('/report/general-indicators')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getMtoSectorIndicators () {
    return new Promise((resolve, reject) => {
      axios.get('/report/mto-sector-indicators')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getAbonentsStatistics () {
    return new Promise((resolve, reject) => {
      axios.get('/report/abonents-statistics')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getDeviceOfflineDailyStatistics ({ dateFrom, dateTo } = {}) {
    const params = new URLSearchParams();
    if (dateFrom) params.append('date_from', dateFrom);
    if (dateTo) params.append('date_to', dateTo);

    const query = params.toString();

    return new Promise((resolve, reject) => {
      axios.get(`/report/device-offline-daily-statistics${query ? `?${query}` : ''}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getDeviceOfflineDailyStatisticsDevices ({ date, type } = {}) {
    const params = new URLSearchParams();
    if (date) params.append('date', date);
    if (type) params.append('type', type);

    const query = params.toString();

    return new Promise((resolve, reject) => {
      axios.get(`/report/device-offline-daily-statistics/devices${query ? `?${query}` : ''}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getDoorphoneAdMetrics ({ dateFrom, dateTo, cityId } = {}) {
    const params = new URLSearchParams();
    if (dateFrom) params.append('date_from', dateFrom);
    if (dateTo) params.append('date_to', dateTo);
    if (cityId !== null && cityId !== undefined && cityId !== '') {
      params.append('city_id', cityId);
    }

    const query = params.toString();

    return new Promise((resolve, reject) => {
      axios.get(`/report/doorphone-ad-metrics${query ? `?${query}` : ''}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  exportDoorphoneAdMetricsCsv ({ dateFrom, dateTo, cityId, section } = {}) {
    const params = new URLSearchParams();
    if (dateFrom) params.append('date_from', dateFrom);
    if (dateTo) params.append('date_to', dateTo);
    if (cityId !== null && cityId !== undefined && cityId !== '') {
      params.append('city_id', cityId);
    }
    if (section) params.append('section', section);

    const query = params.toString();

    return new Promise((resolve, reject) => {
      axios.get(`/report/doorphone-ad-metrics/export-csv${query ? `?${query}` : ''}`, {
        responseType: 'blob',
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
};
